/**
 * @file 应用案例页入口
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';
import {Button} from 'antd';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import Banner from '../../components/banner/Banner';
import CaseList from './components/case-list/CaseList';
import useCaseStore from './caseHooks';

const Case: React.FC = () => {
    const {caseList} = useCaseStore();

    return (
        <div className="page paddle-case-page">
            <Header />
            <Banner
                className="paddle-case-page-banner"
                title="应用案例"
                subtitle="通过飞桨可以实现这些有趣的项目"
            >
                <a href="/consultationandcooperation">
                    <Button
                        className="paddle-case-page-banner-btn"
                        type="primary"
                        size="large"
                    >
                        联系合作
                    </Button>
                </a>
            </Banner>
            <div className="paddle-case-page-container">
                <CaseList caseList={caseList} />
            </div>
            <Footer />
        </div>
    );
};

export default Case;
